export default __webpack_public_path__ + "static/media/icon-about-us.8d1b96dc.svg";